import { breakpoints } from '../theme/breakpoints'
import { colors } from '../theme/colors'
import { variables } from '../theme/variables'

export const theme = {
  breakpoints,
  colors,
  variables
}
